import { css } from "@emotion/react";
import React from "react";
import { useTheme } from "../theme";

const commonStyle = css`
  display: flex;
  align-items: center;
  height: 0.01em;
  max-height: 2em;
  margin-right: 8px;
  white-space: nowrap;
`;

const positionStyle = {
  start: css`
    margin-right: 8px;
  `,
  end: css`
    margin-left: 8px;
  `,
};

export interface InputAdornmentProps extends React.HTMLProps<HTMLDivElement> {
  position: "start" | "end";
  children?: React.ReactNode;
}

export const InputAdornment = ({
  position,
  children,
  ...props
}: InputAdornmentProps) => {
  const { palette } = useTheme();
  return children !== undefined ? (
    <div
      css={[
        css`
          color: ${palette.text.secondary};
        `,
        commonStyle,
        positionStyle[position],
      ]}
      {...props}
    >
      {children}
    </div>
  ) : null;
};
